import styled from "styled-components";

export const BondingColpatriaWrapper = styled.div`


`;